module.exports = __webpack_public_path__ + "img/regComm-1.b5473514.jpg";